export const environment = {
  production: true,
  stationUrl: 'http://localhost:8080/bff/',
};
